<script>
import MarkComponent from '../__components/Mark.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    MarkComponent,
  },
  props: {
    value: {
      type: Array,
    },
  },
  mounted() {
    this.$emit('fixed-label', true);
    this.$emit('show-border', false);
  },
  methods:{
    change(items){
      this.module.set(items);
    }
  }
};
</script>
<template>
  <MarkComponent
    :value="value"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="change"
  />
</template>
